import { useEffect } from "react"
import { useNavigate  } from "react-router-dom"
import { setupInterceptors } from "services/api"

export default function InjectAxiosInterceptors() {
  const navigate = useNavigate()

  useEffect(() => {
    setupInterceptors(navigate)
  }, [navigate])

  // not rendering anything
  return null
}